__turbopack_context__.v({
  "error-general": "ErrorGeneral-module-scss-module__oJXGUW__error-general",
});
